/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

// siehe https://github.com/mui-org/material-ui/issues/17754#issuecomment-683954249

import React, { forwardRef } from "react";
import { IconDefinition } from "@fortawesome/free-brands-svg-icons";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export type FontAwesomeSvgIconProps = Omit<SvgIconProps, "viewBox"> & {
    icon: IconDefinition;
};

const FontAwesomeSvgIcon = forwardRef<SVGSVGElement, FontAwesomeSvgIconProps>((props, ref) => {
    const {
        icon: {
            icon: [width, height, , , svgPathData],
        },
        classes,
        ...svgIconProps
    } = props;

    return (
        <SvgIcon
            ref={ref}
            {...svgIconProps}
            viewBox={`0 0 ${width} ${height}`}
        >
            {typeof svgPathData === "string" ? (
                <path d={svgPathData} />
            ) : (
                svgPathData.map((d, i) => (
                    <path
                        style={{ ...(i === 0 ? { opacity: 0.4 } : {}) }}
                        d={d}
                    />
                ))
            )}
        </SvgIcon>
    );
});

export default FontAwesomeSvgIcon;